import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './styles';

function Dates({ startDate, endDate, isAdaptive = false }) {
  return (
    <Typography variant="desktopH2" component="div" sx={styles.dateBlock}>
      {!!startDate && (
        <Box sx={isAdaptive ? styles.adaptive : styles.main}>
          <Typography component="span" sx={styles.date} className="date">
            {startDate[1]}
          </Typography>
          <Typography
            component="span"
            variant="desktopP3"
            className="description"
          >
            {startDate[2]}
          </Typography>
        </Box>
      )}
      <Typography component="span" sx={styles.hyphen}>
        -
      </Typography>
      {!!endDate && (
        <Box sx={isAdaptive ? styles.adaptive : styles.main}>
          <Typography component="span" sx={styles.date} className="date">
            {endDate[1]}
          </Typography>
          <Typography
            component="span"
            variant="desktopP3"
            className="description"
          >
            {endDate[2]}
          </Typography>
        </Box>
      )}
    </Typography>
  );
}

export default Dates;
